import { object, string } from 'yup';

export const termSchema = object({
	name: string().required(),
});